/**
 * WelcomePage — B-2. 직원 웰컴
 *
 * PENDING 직원 로그인 → AppFrame ContentGuard → /app/welcome
 * C-2-3 소속 신청 성공 → /app/welcome
 *
 * AppFrame 내부(스튜디오 홈 레이아웃) — LeftNav는 스튜디오 홈/프로필/고객센터/알림만 노출(LeftNav.tsx isRestrictedStaff).
 * 마스터(masterYn=Y)가 접근하면 /app 으로 리디렉션.
 */
import { Navigate } from 'react-router';
import { useAuthStore } from '@indipia/shared';

const BLUE_EM = 'var(--indipia-sky-blue-600)';

export function WelcomePage() {
  const masterYn = useAuthStore((s) => s.user?.masterYn);

  if (masterYn === 'Y') return <Navigate to="/app" replace />;
  return (
    <div className="relative flex min-h-full flex-col items-center justify-between overflow-hidden bg-surface px-6 pb-11 pt-14">

      {/* 배경 glow */}
      <div
        className="pointer-events-none absolute left-1/2 top-0 -translate-x-1/2"
        style={{ width: 800, height: 480, background: 'radial-gradient(ellipse at 50% 0%,color-mix(in srgb, var(--indipia-sky-blue-600) 8%, transparent) 0%,transparent 65%)' }}
      />

      {/* Brand */}
      <div className="z-10 flex items-center gap-2">
        <span className="text-[13px] font-extrabold uppercase tracking-[1.5px] text-group">INDIPIA</span>
        <span className="h-1 w-1 rounded-full bg-group opacity-50" />
        <span className="text-[10px] font-semibold uppercase tracking-[2px] text-text-muted">Pro</span>
      </div>

      {/* 중앙 콘텐츠 */}
      <div className="z-10 flex flex-1 flex-col items-center justify-center pb-6 text-center">

        {/* 아이콘 — 정적, 애니메이션 없음 */}
        <div className="relative mb-11 flex h-[100px] w-[100px] items-center justify-center">
          <div
            className="absolute -inset-6 rounded-full"
            style={{ background: 'radial-gradient(ellipse at center,color-mix(in srgb, var(--indipia-sky-blue-600) 16%, transparent) 0%,transparent 65%)' }}
          />
          <div
            className="relative z-10 flex h-[100px] w-[100px] items-center justify-center rounded-full"
            style={{ background: 'color-mix(in srgb, var(--indipia-sky-blue-600) 6%, transparent)', border: '1.5px solid color-mix(in srgb, var(--indipia-sky-blue-600) 20%, transparent)' }}
          >
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={BLUE_EM} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
        </div>

        {/* 헤드라인 */}
        <h1
          className="mb-[18px] text-[44px] font-black leading-[1.15] text-text"
          style={{ letterSpacing: '-2px', wordBreak: 'keep-all' }}
        >
          가입 신청이<br />
          <span style={{ color: BLUE_EM }}>완료됐어요!</span>
        </h1>

        {/* 서브텍스트 */}
        <p
          className="max-w-[420px] text-[15px] leading-[1.85] text-text-muted"
          style={{ letterSpacing: '-.2px', wordBreak: 'keep-all' }}
        >
          사장님의 승인을 기다리고 있어요.<br />
          승인되면 바로 알림을 보내드릴게요.
        </p>
      </div>

    </div>
  );
}
